export default [
  {
    path: '/action-record',
    component: () => import('./views/Index'),
    name: 'action-record',
    redirect: { name: 'action-record-list' },
    children: [
      {
        path: '',
        name: 'action-record-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      }
    ],
  },
]
